/* @flow */
import PropTypes from 'prop-types';
import * as React from 'react';
import gql from 'graphql-tag';
import QuickPromotion from 'entities/QuickPromotion';
import QuickPromotionModal from 'components/QuickPromotionModal.jsx';
import { graphql } from 'react-apollo';
import { mountModal } from 'lib/modal';
import { handleResponse } from 'lib/QuickPromotionActionHandler';
import { ResponseTypes } from 'constants/QuickPromotionConstants';

type Props = {
  emailToken: string,
  promotion?: ?Object,
};

export class MergeSisAccountsModals extends React.Component<Props> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  componentDidMount() {
    this.checkForPrompts();
  }

  componentDidUpdate() {
    this.checkForPrompts();
  }

  stripQuery = () => {
    const { router } = this.context;
    router.replace(router.location.pathname);
  };
  handleConfirm = (promotion: QuickPromotion) => {
    handleResponse(this.context.router, promotion, ResponseTypes.PRIMARY_ACTION, {
      email_confirmation_token: this.props.emailToken,
    });
    this.stripQuery();
  };
  handleCancel = (promotion: QuickPromotion) => {
    handleResponse(this.context.router, promotion, ResponseTypes.SECONDARY_ACTION);
    this.stripQuery();
  };
  shown = false;

  checkForPrompts() {
    const { promotion } = this.props;
    if (!this.shown && promotion) {
      this.shown = true;
      const modal = (
        <QuickPromotionModal
          triggeredContext={'quick_promotions:' + promotion.getPromotion()}
          promotion={promotion}
          onConfirm={this.handleConfirm}
          onCancel={this.handleCancel}
          onRequestHide={() => {}}
        />
      );
      mountModal(modal, this);
    }
  }

  render() {
    return null;
  }
}

const withData = graphql(
  gql`
    query FetchSisMergeQP {
      me {
        id
        uuid
        quick_promotions(selectPromotions: ["sis_merge_existing_accounts"]) {
          promotion
          schema_version
          end_date
          type
          trigger
          header
          body
          image_url
          image_type
          primary_action {
            label
            action
            action_data
          }
          secondary_action {
            label
            action
            action_data
          }
        }
      }
    }
  `,
  {
    props: ({ data }) => {
      if (data.error) {
        return {};
      }
      return data.me ? { promotion: QuickPromotion.fromJSON(data.me.quick_promotions[0]) } : {};
    },
  }
);

export default withData(MergeSisAccountsModals);
